<template>
  <div>
    <v-col cols="12" style="text-align: right">
      <v-btn
        color="success"
        @click="dialogCreate = !dialogCreate"
        v-if="roles.create_product_group"
        >CREATE GROUP</v-btn
      >
    </v-col>

    <v-alert type="error" v-if="informText != ''">
      {{ informText }}
    </v-alert>

    <v-col cols="12">
      <v-data-table :items="listProductGroup" :headers="headers">
        <template v-slot:item.products_length="{ item }">
          {{ item.product_codes.length }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            color="purple"
            x-small
            class="white--text"
            @click="
              itemSelected = item;
              dialogExport = !dialogExport;
            "
            v-if="roles.publish_product_group"
            >export</v-btn
          >
          <v-btn x-small disabled v-else> export </v-btn>
          &nbsp;

          <v-btn
            color="primary"
            x-small
            @click="
              itemSelected = item.group_id;
              dialogEdit = !dialogEdit;
            "
            v-if="showBtn && roles.read_product_group"
          >
            edit
          </v-btn>
          <v-btn x-small disabled v-else> edit </v-btn>
          &nbsp;
          <v-btn
            color="orange"
            x-small
            dark
            @click="deleteItem(item)"
            v-if="showBtn && roles.delete_product_group"
          >
            delete
          </v-btn>
          <v-btn x-small disabled v-else> delete </v-btn>
        </template>
      </v-data-table>
    </v-col>

    <BaseDialog :active.sync="dialogExport" dialog_name="Export Product Group">
      <DialogExport :selectedItem="itemSelected" :username="userName" />
    </BaseDialog>

    <BaseDialog :active.sync="dialogCreate" dialog_name="Create Product Group">
      <DialogCreate />
    </BaseDialog>

    <BaseDialog :active.sync="dialogEdit" dialog_name="Edit Product Group">
      <DialogEdit :groupID="itemSelected" />
    </BaseDialog>
  </div>
</template>

<script>
import axios from "axios";
import Amplify, { Auth } from "aws-amplify";
import DialogCreate from "./c-product-group-action.vue";
import DialogEdit from "./c-product-group-action.vue";
import DialogExport from "./c-dialog-export-product-group.vue";
import BaseDialog from "../Common/c-base-dialog";
import moment from "moment-timezone";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "ProductGroupList",

  components: {
    DialogCreate,
    DialogEdit,
    BaseDialog,
    DialogExport,
  },

  created() {
    this.$root.$refs.productGroup = this;
  },

  data: () => ({
    selected: [],
    showBtn: true,
    itemSelected: "",
    dialogCreate: false,
    dialogEdit: false,
    listProductGroup: [],
    informText: "",
    dialogExport: false,
    headers: [
      {
        text: "Group ID",
        align: "start",
        value: "group_id",
      },
      { text: "Group Name", value: "group_name" },
      { text: "Number Of Products", value: "products_length" },
      { text: "Created Date", value: "created_date" },
      { text: "Actions", value: "actions", sortable: false, width: "20%" },
    ],
    loading: false,
    roles: [],
    userName: "",
  }),

  methods: {
    async loadData() {
      this.loading = true;
      this.listProductGroup = [];
      this.informText = "";
      var currentSession = await this.$root.$refs.App.currentSession(
        "product-group-loadData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        axios
          .get(window.domain + "product-groups", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("response: ", response);
            if (response.data.error_message == "") {
              this.listProductGroup = response.data.data;
              for (var a of this.listProductGroup) {
                a.created_date = moment(a.created_date).format(
                  "YYYY-MM-DD HH:MM"
                );
              }
            } else {
              this.informText = response.data.error_message;
            }

            this.loading = false;
          })
          .catch((error) => {
            console.log("error ", error);
          });
      } else {
        console.log(
          "currentSession product-group-loadData-undefined: ",
          currentSession
        );
      }
    },

    async deleteItem(item) {
      this.showBtn = false;
      var r = confirm("Are you sure you want to delete this group?");
      if (r != false) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "product-group-loadData"
        );

        if (currentSession.accessToken) {
          await axios
            .delete(window.domain + "product-groups/" + item.group_id, {
              headers: { Authorization: currentSession.accessToken },
            })
            .then((response) => {
              console.log("response: ", response);
              if (response.data.error_message == "") {
                var index = this.listProductGroup.indexOf(item);
                this.listProductGroup.splice(index, 1);
              } else {
                this.informText = response.data.error_message;
                this.showBtn = true;
              }
            });
          //.then(this.productTypes.splice(index,1))
        }
      }

      this.showBtn = true;
    },

    turnOffDialog() {
      this.dialogCreate = false;
      this.dialogEdit = false;
      this.dialogExport = false;

      this.loadData();
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("product_group");

    if (this.roles.list_product_groups) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      var currentSession;
      try {
        currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
        console.log("product-group-mounted currentSession: ", currentSession);
      } catch (error) {
        console.log("product-group-mounted error: ", error);
      }

      if (currentSession != undefined) {
        this.userName = currentSession.accessToken.payload.username;
      }
      this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style lang="scss" scoped>
</style>